import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ArquivoImportacaoSva } from '../model/arquivoImportacaoSva';

@Injectable({
  providedIn: 'root'
})
export class ArquivoImportacaoSvaService {

  constructor(private http: HttpClient) { }

  findAll(): Observable<ArquivoImportacaoSva[]> {
    return this.http.get<ArquivoImportacaoSva[]>(`${environment.apiUrl}/arquivo-importacao-sva`);
  }

  findById(id: number) {
    return this.http.get(`${environment.apiUrl}/arquivo-importacao-sva/${id}`);
  }

  findByIdExample(id: number) { }

  // save(importacaoSva: ArquivoImportacaoSva) {
  //   return this.http.post(`${environment.apiUrl}/arquivo-importacao-sva`, importacaoSva);
  // }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/arquivo-importacao-sva/${id}`);
  }

}
